import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const footerLinks = {
    product: [
      { label: 'Features', href: '/features' },
      { label: 'Product Tour', href: '/tour' },
      { label: 'Pricing', href: '/pricing' },
      { label: 'Live Demo', href: '/login?demo=1' },
    ],
    company: [
      { label: 'About', href: '/about' },
      { label: 'Contact', href: '/contact' },
      { label: 'Share Your Story', href: '/share-story' },
    ],
    resources: [
      { label: 'Help Center', href: '/help' },
      { label: 'Video Tutorials', href: '/demo' },
      { label: 'Brochure', href: '/brochure' },
    ],
    legal: [
      { label: 'Security & Trust', href: '/security' },
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
    ],
  };

  return (
    <footer className="bg-ep-text py-16" data-testid="footer">
      <div className="container-custom">
        <div className="grid md:grid-cols-2 lg:grid-cols-6 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-1 mb-4">
              <span className="font-heading text-2xl font-bold text-white">Estate</span>
              <span className="font-heading text-2xl font-bold text-ep-secondary">Pro</span>
              <span className="font-heading text-2xl font-bold text-white">Filer</span>
            </Link>
            <p className="text-white/60 mb-6 max-w-sm">
              Bringing clarity, peace, and professional precision to estate management.
            </p>
            <div className="space-y-2">
              <a href="mailto:support@estateprofiler.com" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors">
                <Mail className="w-4 h-4" strokeWidth={1.5} />
                <span className="text-sm">support@estateprofiler.com</span>
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="font-medium text-white mb-4">Product</h4>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-white/60 hover:text-white transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="font-medium text-white mb-4">Company</h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-white/60 hover:text-white transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h4 className="font-medium text-white mb-4">Resources</h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-white/60 hover:text-white transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-medium text-white mb-4">Legal</h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-white/60 hover:text-white transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/40 text-sm">
            © {new Date().getFullYear()} EstateProFiler. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/login" className="text-white/60 hover:text-white transition-colors text-sm">
              Sign In
            </Link>
            <Link to="/register" className="text-white/60 hover:text-white transition-colors text-sm">
              Get Started
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
